import {castShadow} from "../styles/global";

export default function Home() {

    return (
        <div className={"col max-width align-center"}>
            <img
                className={'portrait-img'}
                src={'thumbs_up_portrait.png'}
            />
            <div
                style={{
                    ...castShadow
                }}
                className={"br-15p bg-white p-40p"}
            >
                <h1>
                    I am Paddleboat
                </h1>
                <p>
                    I am a Full stack software developer, artist, and game developer!

                    I spend too much of my freetime widdling away at little projects. I consider software development to
                    be an art in the way architecture can be an art.
                </p>
                <p>
                    I'm one of those doomsayers that thinks AI will be around for a while. I think it's going to stick
                    like the internet will, but I still think people will make their own art. I think it is incredibly
                    difficult to make a living making art, but people will make art because their heart compels them to
                </p>
            </div>
        </div>
    )
}